import React, { Component } from 'react';
import moment from 'moment';
import {
  format,
  startOfWeek,
  addDays,
  endOfMonth,
  endOfWeek,
  startOfMonth,
  isSameMonth,
  isSameDay,
  addWeeks,
  subMonths,
  addMonths,
} from 'date-fns';
import { dayMap, getUser } from '../common/globals.js';
import withCalendarMonthEndDate from '../common/withCalendarMonthEndDate';

class Calendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentDate: new Date(),
      weekStartsOn: 0
    };
  }

  UNSAFE_componentWillMount() {
    const { weekStart } = getUser();
    this.setState({ weekStartsOn: dayMap[weekStart] });
  }

  renderHeader() {
    const { prevMonth, nextMonth, currentMonth } = this.props;
    const dateFormat = 'MMMM yyyy';
    return (
      <div className="c-year-header">
        <div className="row gx-0">
          <div className="col">
            <button className="btn btn-arrow" onClick={prevMonth}>
              <span>
                <i className="fas fa-chevron-left" />
              </span>
            </button>
          </div>
          <div className="col-6 text-center">
            <span>{format(currentMonth, dateFormat)}</span>
          </div>
          <div className="col text-end">
            <button className="btn btn-arrow" onClick={nextMonth}>
              <span>
                <i className="fas fa-chevron-right" />
              </span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderDays() {
    const { currentMonth } = this.props;
    const { weekStartsOn } = this.state;
    const dateFormat = 'iii';
    const days = [];

    const startDate = startOfWeek(currentMonth, { weekStartsOn });

    for (let i = 0; i < 7; i++) {
      days.push(
        <div className="col" key={i}>
          <span>
            {format(addDays(startDate, i), dateFormat)}
          </span>
        </div>
      );
    }

    return <div className="row gx-2">{days}</div>;
  }

  renderCells() {
    const { currentDate, weekStartsOn } = this.state;
    const {
      onDateClick, selectedDate, dateLogs, currentMonth, calendarMonthEndDate
    } = this.props;

    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart, { weekStartsOn });
    const endDate = endOfWeek(monthEnd, { weekStartsOn });
    const addWeekDate = addWeeks(endDate, 1);
    const dateFormat = 'd';
    const flagDateFormat = 'yyyy-LL-dd';
    const rows = [];

    let days = [];
    let day = startDate;
    let formattedDate = '';

    const getPrevMonth = subMonths(currentMonth, 1);
    const getNextMonth = addMonths(currentMonth, 1);
    const monthEndDates = calendarMonthEndDate.map((item) => moment(item).toDate());

    const currentEndMonthDay = monthEndDates.find(
      (item) => isSameMonth(currentMonth, item)
    );

    const prevEndMonthDay = monthEndDates.find(
      (item) => isSameMonth(getPrevMonth, item)
    );

    const nextEndMonthDay = monthEndDates.find(
      (item) => isSameMonth(getNextMonth, item)
    );

    while (day <= addWeekDate) {
      for (let i = 0; i < 7; i++) {
        formattedDate = format(day, dateFormat);
        const cloneDay = day;
        const flagDate = format(cloneDay, flagDateFormat);

        // eslint-disable-next-line no-loop-func
        dateLogs.map((date) => {
          days.push(
            <div
              className="col c-day"
              key={day}
              onClick={() => onDateClick(cloneDay)}
              style={{ height: '40px' }}
              aria-hidden="true"
            >
              <span
                className={
                  `${date[flagDate] === undefined
                    ? 'c-day'
                    : `c-day ${date[flagDate].border === 'red'
                      ? 'red'
                      : ''
                    }`
                  } 
                ${isSameDay(day, currentDate) ? 'current' : isSameDay(day, selectedDate) ? 'selected' : ''}
                ${currentEndMonthDay !== '' && isSameDay(day, currentEndMonthDay) ? 'month-end-day' : ''}`
                }
              >
                {isSameMonth(day, currentMonth)
                  ? <strong>{currentEndMonthDay !== '' && isSameDay(day, currentEndMonthDay) ? `-${formattedDate}-` : formattedDate}</strong>
                  : (
                    <strong
                      role="presentation"
                      className={
                        `${date[flagDate] === undefined ? 'flagDate-undefined' : 'flagDate'} 
                        ${prevEndMonthDay !== '' && isSameDay(day, prevEndMonthDay) ? 'month-end-day' : ''}
                        ${nextEndMonthDay !== '' && isSameDay(day, nextEndMonthDay) ? 'month-end-day' : ''}`
                      }
                    >{
                        prevEndMonthDay !== '' && isSameDay(day, prevEndMonthDay)
                          ? `-${formattedDate}-`
                          : nextEndMonthDay !== '' && isSameDay(day, nextEndMonthDay)
                            ? `-${formattedDate}-`
                            : formattedDate
                      }
                    </strong>
                  )}
                <span className="cases">
                  {date[flagDate] === undefined ? '' : date[flagDate].count}
                </span>
              </span>
            </div>
          );
        });

        day = addDays(day, 1);
      }

      if (rows.length < 6) {
        rows.push(
          <div className="c-days" key={day}>
            <div className="row gx-2">{days}</div>
          </div>
        );
        days = [];
      }
    }
    return <div>{rows}</div>;
  }

  render() {
    return (
      <div className="col-md-6 ">
        <section className="calender-section sticky-cal-date-filter cursor-pointer">
          {this.renderHeader()}
          <div className="c-days-name">{this.renderDays()}</div>
          {this.renderCells()}
        </section>
      </div>
    );
  }
}

export default withCalendarMonthEndDate(Calendar);
